<template>
  <div class="stats-row">
    <div v-for="item in items" :key="item.key" class="stat-box" :class="item.key">
      <div class="sb-icon"><span class="mdi" :class="item.icon" /></div>
      <div class="sb-body">
        <div class="sb-val">{{ stats[item.valueKey] }}<span class="sb-unit">{{ item.unit }}</span></div>
        <div class="sb-label">{{ item.label }}</div>
      </div>
    </div>
  </div>
</template>

<script setup>
defineProps({
  stats: { type: Object, required: true },
})

const items = [
  { key: 'total', valueKey: 'total', label: '告警总数', icon: 'mdi-bell-outline', unit: '条' },
  { key: 'safety', valueKey: 'safetyCount', label: '影响安全', icon: 'mdi-shield-alert-outline', unit: '条' },
  { key: 'income', valueKey: 'incomeCount', label: '影响收益', icon: 'mdi-currency-cny', unit: '条' },
  { key: 'normal', valueKey: 'normalCount', label: '普通告警', icon: 'mdi-information-outline', unit: '条' },
  { key: 'stations', valueKey: 'stationCount', label: '涉及电站数', icon: 'mdi-lightning-bolt-circle', unit: '个' },
]
</script>

<style scoped lang="scss">
.stats-row {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 14px;
  margin-bottom: 16px;
}

.stat-box {
  background: var(--card-bg);
  border-radius: 12px;
  border: 1px solid #fff;
  box-shadow: var(--shadow-card);
  backdrop-filter: blur(6px);
  padding: 16px 18px;
  position: relative;
  display: flex;
  gap: 12px;
  align-items: center;
  transition: transform 0.2s, box-shadow 0.2s;

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 14px rgba(8, 40, 87, 0.08);
  }
}

.sb-icon {
  width: 42px;
  height: 42px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  flex-shrink: 0;
}

.total .sb-icon,
.stations .sb-icon {
  background: var(--primary-faint);
  color: var(--primary);
}

.safety .sb-icon {
  background: color-mix(in srgb, var(--cat-safety) 12%, #fff);
  color: var(--cat-safety);
}

.income .sb-icon {
  background: color-mix(in srgb, #F59E0B 12%, #fff);
  color: var(--cat-income);
}

.normal .sb-icon {
  background: color-mix(in srgb, var(--cat-normal) 12%, #fff);
  color: var(--cat-normal);
}

.sb-body {
  flex: 1;
}

.sb-val {
  font-size: 24px;
  font-weight: 700;
  color: var(--text-primary);
  line-height: 1.2;
}

.sb-unit {
  margin-left: 2px;
  font-size: 12px;
  font-weight: 400;
  color: var(--text-muted);
}

.sb-label {
  font-size: 12px;
  color: var(--text-muted);
  margin-top: 2px;
}

@media (max-width: 1280px) {
  .stats-row {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media (max-width: 900px) {
  .stats-row {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
